import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// assets
import arrow from '../assets/arrow.png';
const NavLong = ({ content }) => {

    const { name, url } = content;

return (
    <div className={styles.nav}>
    <div className={styles.navTitle}>
        {name}
    </div>
</div>
    );
};

NavLong.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(NavLong);

